import React, { Component, Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { GlgRadio, GlgCheckbox, GlgSelect } from 'SharedComponents'
import DatePicker from 'react-datepicker'
// import CalendarInput from '../../directories/components/filters/calendar_input'
import GlgGeneralIcon from '../../shared/components/glg_general_icon'
import CalendarInputComponent from '../../members_page/components/add_golfers_manually/custom_field_components/calendar_input_component'
import PropTypes from 'prop-types'
import { format, parse } from 'date-fns/esm'
import { FormControl } from 'react-bootstrap'

const AddRemoveFilterButton = (props) => {
  return (
    <icon onClick={ props.onClick } className={ 'bullet-button ' + props.type }>
      <div className='icon'>
        <GlgGeneralIcon icon={ props.icon } />
      </div>
      <div className='vertical-align'>
        { props.text }
      </div>
    </icon>
  )
}

class RecipientListComponent extends Component {
  constructor(props){
    super(props)

    this.membershipHasRenewal = this.membershipHasRenewal.bind(this)
  }

  membershipHasRenewal(membershipId) {
    const membership = this.props.membershipPrograms.find( membership => membership.value === membershipId )
    return membership.hasRenewal
  }

  render(){
    const {
      recipientList: {
        membershipProgram,
        gender,
        age,
        handicapIndex,
        customField,
        campaignActivity,
        roundAttendance,
      },
      membershipPrograms,
      customFieldsAndAnswers,
      customerCanUseMembershipPrograms,
      toggleFilter,
      setGender,
      setAge,
      toggleRoundAttendanceOption,
      setHandicapIndex,
      addNewFilter,
      removeFilter,
      setFilterAttributeValue,
      setDropdownFilterValue,
      setTextFieldFilterValue,
      triggers,
      textMessageChannelChecked,
    } = this.props

    const defaultCustomFieldAnswerValue = [ {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.select_field_value'), value: 'default'} ]
    return (
      <div>
        {((triggers.eventEnd.checked || triggers.roundEnd.checked) && !textMessageChannelChecked) && (
            <p className='add-margin-top-10'>
              { window.I18n.t('marketing_campaigns.components.recipient_list_component.filter') }
              <strong>
                { window.I18n.t('marketing_campaigns.components.recipient_list_component.event_roster') }
              </strong>
              { window.I18n.t('marketing_campaigns.components.recipient_list_component.filter_by') }
            </p>
        )}
        {((!triggers.eventEnd.checked && !triggers.roundEnd.checked) || textMessageChannelChecked) && (
          <p className='add-margin-top-10'>
            { window.I18n.t('marketing_campaigns.components.recipient_list_component.filter_mr') }
          </p>
        )}
        <div className='filters-box'>
          {(customerCanUseMembershipPrograms && !triggers.roundEnd.checked && !triggers.eventEnd.checked) && (
            <Fragment>
              <Row>
                <Col className='revert-grid add-padding-left-30' xs={ 12 }>
                  <GlgCheckbox
                    label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.membership_program') }
                    name="recipientList[membershipProgram]"
                    checked={membershipProgram.checked}
                    onChange={ toggleFilter('membershipProgram') } />
                </Col>
              </Row>
              <Row>
                { membershipProgram.checked && (
                  <Fragment>
                    {membershipProgram.filters.map( (filter) => {
                      return (
                        <Row className='vertical-align no-margin-left add-margin-top-20' key={filter.id}>
                          <Col className='col-xs-offset-1 col-sm-offset-0' xs={ membershipProgram.filters.length > 1 ? 9 : 10 } sm={ membershipProgram.filters.length > 1 ? 11 : 12 }>
                            <Row className='vertical-align'>
                              <Col className='add-margin-top-5 add-padding-left-55 no-padding-right' xs={ 12 } sm={3} md={ 3 } lg={ 2 }>
                                <GlgSelect
                                  items={ [ {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.include'), value: 'include'}, {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.exclude'), value: 'exclude'} ] }
                                  defaultValue={ filter.includeExclude }
                                  onChange={ setDropdownFilterValue('membershipProgram', filter.id, 'includeExclude') } />
                              </Col>
                              <Col className='text-right' xs={ 6 } sm={ 3 } md={ 3 } lg={ 2 }>
                                { window.I18n.t('marketing_campaigns.components.recipient_list_component.golfers_part_of', window.participantFormats) }
                              </Col>
                              <Col className='add-margin-top-5 no-padding' xs={ 6 } sm={ 4 } md={ 3 } lg={2}>
                                <GlgSelect
                                  items={ membershipPrograms }
                                  defaultValue={ filter.membershipId }
                                  onChange={ setDropdownFilterValue('membershipProgram', filter.id, 'membershipId') } />
                              </Col>
                              {this.membershipHasRenewal(filter.membershipId) && (
                                <Fragment>
                                  <Col className='add-margin-top-5 visible-md' xs={ 6 } sm={ 3 } md={ 3 }></Col>
                                  <Col className='text-right add-margin-top-5 col-md-offset-3 col-sm-offset-3 col-lg-offset-0' xs={ 6 } sm={ 3} md={ 3 } lg={ 2 }>
                                    { window.I18n.t('marketing_campaigns.components.recipient_list_component.with_expiration_date') }
                                  </Col>
                                  <Col className='add-margin-top-5 no-padding' xs={ 6 } sm={ 2 } lg={ 2 }>
                                    <GlgSelect
                                      items={ [ {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.equal_to'), value: 'equal'}, {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.greater_or_equal_to'), value: 'greaterOrEqual'} ] }
                                      defaultValue={ filter.equalGreaterOrEqual }
                                      onChange={ setDropdownFilterValue('membershipProgram', filter.id, 'equalGreaterOrEqual') } />
                                  </Col>
                                  <Col className='add-margin-top-5 vertical-align' xs={ 12 } sm={3} md={ 3 } lg={ 2 }>
                                    <FormControl
                                      className='small_box'
                                      type="text"
                                      defaultValue={ filter.days }
                                      onChange={ (e) => { setTextFieldFilterValue('membershipProgram', filter.id, 'days', e.target.value) } } />
                                    <div className='add-margin-left-5'>
                                      { window.I18n.t('marketing_campaigns.components.recipient_list_component.days_from_now') }
                                    </div>
                                  </Col>
                                </Fragment>
                              )}
                            </Row>
                          </Col>
                          <Col xs={ 2 } sm={ 1 }>
                            <Row className='add-margin-top-5 vertical-align'>
                              { membershipProgram.filters.length > 1 && (
                                <Col xs={ 11 }>
                                  <icon className='fas fa-trash-alt' onClick={ () => { removeFilter('membershipProgram', filter.id) } } />
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      )
                    })}
                    <Row className='vertical-align no-margin-left add-margin-top-20 add-margin-bottom-30'>
                      <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-55' xs={ 11 }>
                        <AddRemoveFilterButton
                          type={ 'add' }
                          onClick={ () => { addNewFilter('membershipProgram') } }
                          icon={ 'gga-circle-plus' }
                          text={ window.I18n.t('marketing_campaigns.components.recipient_list_component.add_filter') } />
                      </Col>
                    </Row>
                  </Fragment>
                )}
              </Row>
            </Fragment>
          )}
          <Row>
            <Col className='revert-grid add-padding-left-30' xs={ 12 }>
              <GlgCheckbox
                label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.gender') }
                name="recipientList[gender]"
                checked={gender.checked}
                onChange={ toggleFilter('gender') } />
            </Col>
          </Row>
          { gender.checked && (
            <Row className='no-margin-left vertical-align add-margin-top-20'>
              <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-55' xs={ 12 }>
                <GlgRadio
                  label="M"
                  value="M"
                  name="filter[gender]"
                  checked={gender.selected === 'M'}
                  inline={ true }
                  onChange={ setGender('M') } />
                <GlgRadio
                  label="F"
                  value="F"
                  name="filter[gender]"
                  checked={gender.selected === 'F'}
                  inline={ true }
                  onChange={ setGender('F') } />
              </Col>
            </Row>
          )}

          <Row>
            <Col className='revert-grid add-padding-left-30' xs={ 12 }>
              <GlgCheckbox
                label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.age') }
                name="recipientList[age]"
                checked={ age.checked }
                onChange={ toggleFilter('age') } />
            </Col>
          </Row>
          { age.checked && (
            <Fragment>
              <Row className='vertical-align'>
                <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-55' xs={ 12 }>
                  <Row className='vertical-align'>
                    <Col xs={ 5 } sm={ 3 } lg={ 2 }>
                      { window.I18n.t('marketing_campaigns.components.recipient_list_component.date_to_calculate_age') }
                    </Col>
                    <Col xs={ 5 } lg={ 1 } style={{display: 'flex', width: '200px'}}>
                      <DatePicker
                        name="recipientList[dateAge]"
                        selected={ age.date ? parse(age.date, 'MM/dd/yyyy', new Date()) : null}
                        locale={window.I18n.locale}
                        showMonthDropdown={true}
                        showYearDropdown={true}
                        customInput={<CalendarInputComponent />}
                        maxDate={new Date()}
                        onChange={(e) => { setAge('date', format(e, 'MM/dd/yyyy')) }}
                        popperModifiers={{
                          preventOverflow: {
                            enabled: true,
                            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                            boundariesElement: 'viewport',
                          },
                        }} />
                    </Col>
                  </Row>
                  <Row className='vertical-align add-margin-top-10'>
                    <Col xs={ 7 } sm={ 3 } lg={ 2 }>
                      { window.I18n.t('marketing_campaigns.components.recipient_list_component.minimum_age') }
                    </Col>
                    <Col xs={ 5 } lg={ 1 }>
                      <FormControl
                        className='small_box'
                        type="text"
                        name="recipientList[minAge]"
                        defaultValue={ age.minimum }
                        onChange={ (e) => { setAge('minimum', e.target.value) } } />
                    </Col>
                  </Row>
                  <Row className='vertical-align add-margin-top-10'>
                    <Col xs={ 7 } sm={ 3 }  lg={ 2 }>
                      { window.I18n.t('marketing_campaigns.components.recipient_list_component.maximum_age') }
                    </Col>
                    <Col xs={ 5 } lg={ 1 }>
                      <FormControl
                        className='small_box'
                        type="text"
                        name="recipientList[maxAge]"
                        defaultValue={ age.maximum }
                        onChange={ (e) => { setAge('maximum', e.target.value) } } />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Fragment>
          )}

          <Row>
            <Col className='revert-grid add-padding-left-30' xs={ 12 }>
              <GlgCheckbox
                label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.handicap_index') }
                name="recipientList[handicapIndex]"
                checked={ handicapIndex.checked }
                onChange={ toggleFilter('handicapIndex') } />
            </Col>
          </Row>
          { handicapIndex.checked && (
            <Fragment>
              <Row className='vertical-align'>
                <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-55' xs={ 12 }>
                  <Row className='vertical-align'>
                    <Col xs={ 7 } sm={ 3 } lg={ 2 }>
                      { window.I18n.t('marketing_campaigns.components.recipient_list_component.min_hi') }
                    </Col>
                    <Col xs={ 5 } lg={ 1 }>
                      <FormControl
                        className='small_box medium_box'
                        type="text"
                        name="recipientList[minHandicap]"
                        defaultValue={ handicapIndex.minimumValue }
                        onChange={ (e) => { setHandicapIndex('minimumValue', e.target.value) } }
                        autoFocus={ true } />
                    </Col>
                  </Row>
                  <Row className='vertical-align add-margin-top-10'>
                    <Col xs={ 7 } sm={ 3 } lg={ 2 }>
                      { window.I18n.t('marketing_campaigns.components.recipient_list_component.max_hi') }
                    </Col>
                    <Col xs={ 5 } lg={ 1 }>
                      <FormControl
                        className='small_box medium_box'
                        type="text"
                        name="recipientList[maxHandicap]"
                        defaultValue={ handicapIndex.maximumValue }
                        onChange={ (e) => { setHandicapIndex('maximumValue', e.target.value) } } />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Fragment>
          )}

          <Row>
            <Col className='revert-grid add-padding-left-30' xs={ 12 }>
              <GlgCheckbox
                label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.custom_field') }
                name="recipientList[customField]"
                checked={ customField.checked }
                onChange={ toggleFilter('customField') } />
            </Col>
          </Row>
          {customField.checked && (
            <Row>
              <Fragment>
                {customField.filters.map( (filter) => {
                  return (
                    <Row className='vertical-align no-margin-left add-margin-top-20' key={filter.id}>
                      <Col className='col-xs-offset-1 col-sm-offset-0' xs={ customField.filters.length > 1 ? 9 : 10 } sm={ customField.filters.length > 1 ? 11 : 12 }>
                        <Row className='vertical-align'>
                          <Col className='add-margin-top-5 add-padding-left-55 no-padding-right' xs={ 12 } sm={3} md={ 3 } lg={ 2 }>
                            <GlgSelect
                              items={ [ {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.include'), value: 'include'}, {label: window.I18n.t('marketing_campaigns.components.recipient_list_component.exclude'), value: 'exclude'} ] }
                              defaultValue={ filter.includeExclude }
                              onChange={ setDropdownFilterValue('customField', filter.id, 'includeExclude') } />
                          </Col>
                          <Col className='text-right' xs={ 6 } sm={ 3 } md={ 3 } lg={ 2 }>
                            { window.I18n.t('marketing_campaigns.components.recipient_list_component.golfers_with', window.participantFormats) }
                          </Col>
                          <Col className='add-margin-top-5 no-padding' xs={ 6 } sm={ 4 } md={ 3 } lg={2}>
                            <GlgSelect
                              items={ customFieldsAndAnswers.fields }
                              searchable={true}
                              defaultValue={ filter.customFieldId }
                              onChange={ setDropdownFilterValue('customField', filter.id, 'customFieldId') } />
                          </Col>
                          <Col className='add-margin-top-5 visible-md' xs={ 6 } sm={ 3 } md={ 3 }></Col>
                          <Col className='text-right add-margin-top-5 col-md-offset-3 col-sm-offset-3 col-lg-offset-0' xs={ 6 } sm={ 3} md={ 3 } lg={ 2 }>
                            { window.I18n.t('marketing_campaigns.components.recipient_list_component.equal_to') }
                          </Col>
                          <Col className='add-margin-top-5 no-padding' xs={ 6 } sm={ 2 } md={ 3 } lg={ 2 }>
                            <GlgSelect
                              items={ customFieldsAndAnswers.answers[filter.customFieldId] || defaultCustomFieldAnswerValue }
                              value={ filter.customFieldValue }
                              searchable={true}
                              onChange={ setDropdownFilterValue('customField', filter.id, 'customFieldValue') } />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={ 2 } sm={ 1 }>
                        <Row className='add-margin-top-5 vertical-align'>
                          {customField.filters.length > 1 && (
                            <Col xs={ 11 }>
                              <icon className='fas fa-trash-alt' onClick={ () => { removeFilter('customField', filter.id) } } />
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  )}
                )}
                <Row className='vertical-align no-margin-left add-margin-top-20 add-margin-bottom-30'>
                  <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-55' xs={ 11 }>
                    <AddRemoveFilterButton
                      type={ 'add' }
                      onClick={ () => { addNewFilter('customField') } }
                      icon={ 'gga-circle-plus' }
                      text={ window.I18n.t('marketing_campaigns.components.recipient_list_component.add_filter') } />
                  </Col>
                </Row>
              </Fragment>
            </Row>
          )}
            <Row>
              <Col className='revert-grid add-padding-left-30' xs={ 12 }>
                <GlgCheckbox
                  label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.campaign_activity') }
                  name="recipientList[campaignActivity]"
                  checked={ campaignActivity.checked }
                  onChange={ toggleFilter('campaignActivity') } />
              </Col>
            </Row>
            { campaignActivity.checked && (
              <Row className='vertical-align'>
                <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-40' xs={ 11 }>
                  { window.I18n.t('marketing_campaigns.components.recipient_list_component.exclude_golfers', window.participantFormats) }
                  <FormControl
                    className='small_box'
                    type="text"
                    defaultValue={ campaignActivity.days }
                    onChange={ (e) => { setFilterAttributeValue('campaignActivity', 'days', e.target.value) } } />
                  { window.I18n.t('marketing_campaigns.components.recipient_list_component.days') }
                </Col>
              </Row>
            )}
            {(triggers.roundEnd.checked && !textMessageChannelChecked) && (
              <Fragment>
                <Row>
                  <Col className='revert-grid add-padding-left-30' xs={ 12 }>
                    <GlgCheckbox
                      label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.round_attendance') }
                      name="recipientList[roundAttendance]"
                      checked={ roundAttendance.checked }
                      onChange={ toggleFilter('roundAttendance') } />
                  </Col>
                </Row>
                {roundAttendance.checked && (
                  <Row className='no-margin-left vertical-align add-margin-top-20'>
                    <Col className='col-xs-offset-1 col-sm-offset-0 add-padding-left-55' xs={ 12 }>
                      <GlgCheckbox
                        label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.confirmed_players', window.participantFormats) }
                        value="confirmed"
                        name="filter[roundAttendance]"
                        checked={ roundAttendance.selected.includes('confirmed') }
                        inline={ true }
                        onChange={ toggleRoundAttendanceOption('confirmed') } />
                      <GlgCheckbox
                        label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.guests') }
                        value="guest"
                        name="filter[roundAttendance]"
                        checked={ roundAttendance.selected.includes('guest') }
                        inline={ true }
                        onChange={ toggleRoundAttendanceOption('guest') } />
                      <GlgCheckbox
                        label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.waitlisted_players', window.participantFormats) }
                        value="waitlisted"
                        name="filter[roundAttendance]"
                        checked={ roundAttendance.selected.includes('waitlisted') }
                        inline={ true }
                        onChange={ toggleRoundAttendanceOption('waitlisted') } />
                      <GlgCheckbox
                        label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.invited_players', window.participantFormats) }
                        value="invited"
                        name="filter[roundAttendance]"
                        checked={ roundAttendance.selected.includes('invited') }
                        inline={ true }
                        onChange={ toggleRoundAttendanceOption('invited') } />
                      <GlgCheckbox
                        label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.not_in_playing_divisions') }
                        value="playingDivisions"
                        name="filter[roundAttendance]"
                        checked={ roundAttendance.selected.includes('playingDivisions') }
                        inline={ true }
                        onChange={ toggleRoundAttendanceOption('playingDivisions') } />
                      <GlgCheckbox
                        label={ window.I18n.t('marketing_campaigns.components.recipient_list_component.not_attending', window.participantFormats) }
                        value="notAttending"
                        name="filter[roundAttendance]"
                        checked={ roundAttendance.selected.includes('notAttending') }
                        inline={ true }
                        onChange={ toggleRoundAttendanceOption('notAttending') } />
                    </Col>
                  </Row>
                )}
              </Fragment>
            )}
        </div>
        <div className='note-box'>
          <div className='note-header'>
            { window.I18n.t('marketing_campaigns.components.recipient_list_component.note') }
            <strong>
              { window.I18n.t('marketing_campaigns.components.recipient_list_component.automatically_excluded') }
            </strong>
            { window.I18n.t('marketing_campaigns.components.recipient_list_component.from_campaign') }
          </div>
          <div className='note-body'>
            <div className='note-body-row add-margin-top-10'>
              { window.I18n.t('marketing_campaigns.components.recipient_list_component.unsubscribed', window.participantFormats) }
            </div>
            <div className='note-body-row'>
              { window.I18n.t('marketing_campaigns.components.recipient_list_component.not_valid', window.participantFormats) }
            </div>
            {((!triggers.eventEnd.checked && !triggers.roundEnd.checked) || textMessageChannelChecked) && (
              <Fragment>
                <div className='note-body-row'>
                  { window.I18n.t('marketing_campaigns.components.recipient_list_component.already_registered', window.participantFormats) }
                </div>
                <div className='note-body-row'>
                  { window.I18n.t('marketing_campaigns.components.recipient_list_component.not_included', window.participantFormats) }
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    )
  }
}

AddRemoveFilterButton.propTypes = {
  type: PropTypes.string.isRequired,
  icon: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

RecipientListComponent.propTypes = {
  recipientList: PropTypes.shape({
    gender: PropTypes.shape({
      checked: PropTypes.bool.isRequired,
      selected: PropTypes.string.isRequired,
    }).isRequired,
    handicapIndex: PropTypes.shape({
      checked: PropTypes.bool.isRequired,
      minimumValue: PropTypes.string.isRequired,
      maximumValue: PropTypes.string.isRequired,
    }).isRequired,
    membershipProgram: PropTypes.any,
    age: PropTypes.any,
    customField: PropTypes.any,
    campaignActivity: PropTypes.any,
    roundAttendance: PropTypes.shape({
      checked: PropTypes.bool.isRequired,
      selected: PropTypes.array.isRequired,
    }).isRequired,
  }),
  membershipPrograms: PropTypes.array.isRequired,
  customFieldsAndAnswers: PropTypes.object.isRequired,
  customerCanUseMembershipPrograms: PropTypes.bool.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  setGender: PropTypes.func.isRequired,
  setAge: PropTypes.func.isRequired,
  toggleRoundAttendanceOption: PropTypes.func.isRequired,
  setHandicapIndex: PropTypes.func.isRequired,
  addNewFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  setFilterAttributeValue: PropTypes.func.isRequired,
  setDropdownFilterValue: PropTypes.func.isRequired,
  setTextFieldFilterValue: PropTypes.func.isRequired,
  textMessageChannelChecked: PropTypes.bool.isRequired,
  triggers: PropTypes.shape({
    eventEnd: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
    roundEnd: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
  }),
}

CalendarInputComponent.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
}

export default RecipientListComponent
